import { Tabs } from '@gate/gui'
import { useTranslation } from 'next-i18next'

import { EnumCoinLineTimeTab } from '@/constants/index'
import { PriceChartTimeTabStyled } from 'blocks/Price/PriceChart/style'
import React from 'react'

export type PriceTrendValueType = string & EnumCoinLineTimeTab[keyof EnumCoinLineTimeTab]

interface PriceTrendTabProps {
  priceTrendValue: PriceTrendValueType
  handlePriceTrendChange: (val: PriceTrendValueType) => void
  isShow: boolean
}

/**
 * @description: 趋势图 ｜ 代币表现图 tabs
 * @param {object} param1
 * @return {*}
 */
const PriceTrendTab: React.FC<PriceTrendTabProps> = ({
  priceTrendValue,
  handlePriceTrendChange,
  isShow,
}): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <PriceChartTimeTabStyled isShow={isShow}>
      <Tabs
        w={'100%'}
        size={'xs'}
        type="fourth-capsule-grey"
        defaultValue={EnumCoinLineTimeTab.ONE_DAY}
        value={priceTrendValue}
        onTabChange={(tab: PriceTrendValueType) => {
          handlePriceTrendChange(tab)
        }}
      >
        <Tabs.List style={{ flexWrap: 'nowrap' }}>
          <Tabs.Tab value={EnumCoinLineTimeTab.ONE_DAY}>
            <span>{t(`P.1D`)}</span>
          </Tabs.Tab>
          <Tabs.Tab value={EnumCoinLineTimeTab.SEVEN_DAY}>
            <span>{t(`P.7D`)}</span>
          </Tabs.Tab>
          <Tabs.Tab value={EnumCoinLineTimeTab.ONE_MONTH}>
            <span>{t(`P.timeM`, { time: 1 })}</span>
          </Tabs.Tab>
          <Tabs.Tab value={EnumCoinLineTimeTab.ONE_YEAR}>
            <span>{t(`P.1Y`)}</span>
          </Tabs.Tab>
          <Tabs.Tab value={EnumCoinLineTimeTab.ALL}>
            <span>{t('P.All')}</span>
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </PriceChartTimeTabStyled>
  )
}

export default PriceTrendTab
